import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'

const Oatdashboardmain = () => {
  return (
    <>
    
    <div className='oat-addmain'>
     <h2 id="OatDash-headA">Welcome To</h2>   
    <h1 id="OatDash-head"><span>O</span><span>A</span><span>T&nbsp;</span><span>V</span><span>E</span><span> </span><span>N</span><span>T</span><span>U</span><span>R</span><span> </span><span>E</span><span>!</span><span>!</span></h1>
    </div>
    </>
  )
}

export default Oatdashboardmain
